<template>
    <div class="form-group row">
        <label v-if="showlabel" :for="id" class="col-12 col-form-label main">{{getlabel}}</label>
        <div :class="inputcolsize">
            <input id="id" type="text" :class="isInvalid + ' ' + cssclass +' form-control'" :maxlength="maxlength"
                   v-model="model" :placeholder="placeholder" />
        </div>
        <div class="col-12">
            <span class="errormsg">{{errorMsg | capitalizeFirstLetter}}</span>
        </div>
        <div class="col-12">
            <span class="errormsg">{{parenterr | firstError | capitalizeFirstLetter}}</span>
        </div>
    </div>
</template>

<script>
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';

    export default {
        name: 'form-input',
        props: {
            id:"",
            label: "",
            maxlength: "",
            placeholder: "",
            editmodel: "",
            required: false,
            validations: {},
            cssclass:"" ,
            parenterr: {},
            inputcolsize: { default: "col-12" },
            showlabel: { default: true },
            validationmsgs: {}
        },
        watch: {
            model: {
                handler(val) {
                    this.evalRequired(false);
                    this.$emit('onmodelchange', val);
                }
            },
            editmodel: {
                handler(val) {
                    this.model = val;
                }
            } 
        },
        computed: {
            getlabel: function () {
                return this.required ? this.label + ' *' : this.label;
            },
        },
        data: function () {
            return {
                model: "",
                isInvalid: "",
                errorMsg:"",
            }
        },
        created: function () {
            this.model = this.editmodel;
            //this.evalRequired(true);
        },
        methods: {
            evalRequired: function (runbasic) {
                this.isInvalid = "";
                this.errorMsg = "";
                var vmsg = this.validationmsgs;
                if (!this.model && this.required) {
                    this.$emit('onmodelerror', this.model);
                    this.isInvalid = "is-invalid";
                    this.errorMsg = this.label.toLowerCase().replace(/[\*,\:]/g, '') + vmsg.required;
                    return;
                }
                
                if (!this.validations || this.validations.length <= 0 || runbasic===true || this.model=="") {
                    this.$emit('onmodelvalid', this.model);
                    return;
                }
               
                var supportedValidations = this.supportedValidations();
                var isvalid = true;

                for (var i = 0; i < this.validations.length; i++) {
                    var ev = supportedValidations[this.validations[i]](this.model);
                    if (ev === true) {
                        continue;
                    }
                    else {
                        this.$emit('onmodelerror', this.model);
                        this.isInvalid = "is-invalid";
                        this.errorMsg = ev;
                        isvalid = false;
                        break;
                    }
                }

                if (isvalid) {
                    this.$emit('onmodelvalid', this.model);
                }
            },
            supportedValidations: function () {
                var vmsgs = this.validationmsgs;
                return {
                    phonenumber: function (m) {
                        if ((/^\d{4,}$/).test(m.replace(/[\s()+\-\.]|ext/gi, ''))) {
                            return true;
                        }
                        return vmsgs.invalidPhoneNumber;
                    },
                    usaphonenumber: function (m) {
                        if ((/^\d{10,}$/).test(m.replace(/[\s()+\-\.]|ext/gi, ''))) {
                            return true;
                        }
                        return vmsgs.invalidUSNumber;
                    },
                    email: function (m) {
                        if ((/^\S+@\S+\.\S+$/).test(m)) {
                            return true;
                        }
                        return vmsgs.invalidEmail;
                    },
                    zip: function (m) {
                        if ((/^[0-9]{5}(?:-[0-9]{4})?$/).test(m)) {
                            return true;
                        }
                        return vmsgs.invalidZip;
                    }
                }
            },
           
           
        },
    }
</script>